import axios from '@/services/axios'

export const WorkPlanFunctionsMixin = {
  data: function() {
    return {}
  },
  filters: {},
  computed: {},
  methods: {
    async setRowStatus(docId, workID, status) {
      const res = await axios
        .request({
          url: '/SetRowStatus',
          params: {
            id: docId,
            workID: workID,
            newStatus: status,
          },
        })
        .then(() => {
          return status
        })
        .catch(() => {
          return false
        })
      return res
    },
    async startWorks(docId, rowData) {
      if (!docId) {
        return false
      }
      const res = await axios
        .request({
          url: '/StartWorks',
          params: {
            id: docId,
          },
        })
        .then(resp => {
          if (resp.data.status === '0') {
            this.setIndication(docId, 1, resp.data.durationOfWorks)
            return true
          } else {
            const message = `Ошибка начала работ по документу: ${resp.data.statusDescription}`
            console.error(message, resp)
            if (resp.data.status === '24001') {
              this.showConfirmDialog_(
                resp.data.previousDocument,
                'closePreviousDocument',
                resp.data.previousDocumentNumber,
                resp.data.previousDocumentDescription,
                rowData
              )
            } else {
              this.$emit('showSnack', { color: 'error', text: message })
            }
            return false
          }
        })
        .catch(error => {
          console.error('111')
          const message = `Ошибка начала работ по документу: ${error}`
          console.error(message, error)
          this.$emit('showSnack', { color: 'error', text: message })
          return false
        })
      return res
    },
    showConfirmDialog_(
      id,
      dialogID,
      number,
      description,
      rowData,
      onlyComplete
    ) {
      var dialogData = {}
      dialogData.dialogID = dialogID
      if (!dialogData.dialogID) dialogData.dialogID = 'closePreviousDocument'
      dialogData.previousDocument = id
      dialogData.previousDocumentNumber = number
      dialogData.previousDocumentDescription = description
      dialogData.dialogMessage = 'Завершить работы по ЗН №' + number + '?'
      dialogData.dialogDescription = description
      dialogData.rowData = rowData
      if (onlyComplete) {
        dialogData.textAction1 = ''
        dialogData.textAction2 = 'Завершить'
      } else {
        dialogData.textAction1 = 'Пауза'
        dialogData.textAction2 = 'Завершить'
      }
      this.showConfirmDialog(dialogData)
    },
    async stopWorks(workIsCompleted, docId, dialogData) {
      if (!docId) {
        return false
      }
      if (dialogData) {
        this.showConfirmDialog_(
          dialogData.docId,
          'closeCurrentDocument',
          dialogData.number,
          dialogData.description,
          dialogData.rowData,
          dialogData.onlyComplete
        )
        return false
      }
      const res = await axios
        .request({
          url: '/StopWorks',
          params: {
            id: docId,
            isCompleted: workIsCompleted,
          },
        })
        .then(resp => {
          if (resp.data.status === '0') {
            this.stopIndication(
              docId,
              workIsCompleted,
              workIsCompleted === 1 ? 0 : 1
            )
            return true
          } else {
            const message = `Ошибка окончания работ по документу: ${resp.data.statusDescription}`
            console.error(message, resp)
            this.$emit('showSnack', { color: 'error', text: message })
            return false
          }
        })
        .catch(error => {
          const message = `Ошибка окончания работ по документу: ${error.response}`
          console.error(message, error.response)
          this.$emit('showSnack', { color: 'error', text: message })
          return false
        })
      return res
    },
  },
}
